import { render } from "./TargetContainer.vue?vue&type=template&id=384eff58&scoped=true"
import script from "./TargetContainer.vue?vue&type=script&lang=js"
export * from "./TargetContainer.vue?vue&type=script&lang=js"

import "./TargetContainer.vue?vue&type=style&index=0&id=384eff58&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-384eff58"

export default script